
import Vue from "vue";
import store from "@/store";
import { LOYALTY } from "@/store/loyalty";
import { IRootState } from "@/store/types";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { mapState } from "vuex";

import { getFlyBuysEarnRate, getAirpointsEarnRate } from "@/helpers/loyalty";

export default Vue.extend({
  data() {
    return {
      detailRouteName: LOYALTY_ROUTE_NAMES.SEGMENT_OFFER_DETAILS,
      isLoading: false,
      headers: [
        { text: "Customer Segment", value: "segmentName" },
        { text: "Eligible?", value: "isEligible" },
        { text: "Level", value: "level" },
        { text: "Channel", value: "channelList", sortable: false },
        {
          text: "Fly Buys earn rate / point",
          value: "flyBuysEarnRate",
          sortable: false
        },
        {
          text: "Airpoints earn rate / Airpoints $",
          value: "airpointsEarnRate",
          sortable: false
        }
      ]
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.loyalty.dataTables.segmentOffers.pagination;
      },
      set(value: string) {
        this.$store.commit(
          LOYALTY.NS(LOYALTY.MUTATIONS.SET_SEGMENT_OFFER_PAGINATION),
          value
        );
      }
    },
    ...mapState({
      segmentOfferList: (state: IRootState) =>
        state.loyalty.segmentOfferList.map(item => ({
          ...item,
          segmentName: item.segment.value,
          channelList: item.channels.map(channel => channel.value).join(", "),
          flyBuysEarnRate: getFlyBuysEarnRate(item),
          airpointsEarnRate: getAirpointsEarnRate(item)
        }))
    })
  },
  methods: {
    onItemClick(item: any) {
      this.$router.push({
        name: (this as any).detailRouteName,
        params: { id: item.id }
      });
    }
  },
  async mounted() {
    (this as any).isLoading = true;

    await this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_SEGMENT_OFFER_LIST)
    );

    (this as any).isLoading = false;
  }
});
